import { render, staticRenderFns } from "./IconFlagSolid.vue?vue&type=template&id=a07765dc"
import script from "./IconFlagSolid.vue?vue&type=script&lang=js"
export * from "./IconFlagSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports